var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevateLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 12,
    viewBox: "0 0 74 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8038 6.72536H3.71054V10.1531H7.61142L7.71989 8.71859H9.56186V11.998H0V10.5554L1.28733 10.3075V1.69861L0 1.45073V0H9.54753V3.2875H7.68715L7.57867 1.85303H3.71054V4.8703H7.8038V6.72536Z",
    fill: "#BA2025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8594 12V10.5574L12.1467 10.3095V1.69861L10.8594 1.45073V0H15.8654V1.45073L14.5699 1.69861V10.1531H17.9816L18.0983 8.64544H19.9505V12H10.8594Z",
    fill: "#BA2025"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6242 6.72536H24.5309V10.1531H28.4318L28.5403 8.71859H30.3823V11.998H20.8184V10.5554L22.1057 10.3075V1.69861L20.8184 1.45073V0H30.3659V3.2875H28.5055L28.397 1.85303H24.5289V4.8703H28.6222V6.72536H28.6242Z",
    fill: "#BA2025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9127 1.45073L34.9917 1.61531L37.1346 8.81002L37.284 9.47037H37.3331L37.4743 8.82831L39.6253 1.61734L38.7125 1.45276V0H43.1291V1.45073L42.1161 1.5828L38.5549 12H36.0642L32.4928 1.5828L31.4961 1.45073V0H35.9127V1.45073Z",
    fill: "#BA2025"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9141 10.5574L42.7777 10.4335L46.4555 0H48.9381L52.5913 10.4335L53.455 10.5574V12H49.3372V10.5574L50.1763 10.4091L49.6442 8.76126H45.7249L45.1928 10.4091L46.0319 10.5574V12H41.9141V10.5574ZM46.2979 6.9895H49.0711L47.7101 2.76126H47.661L46.3 6.9895H46.2979Z",
    fill: "#BA2025"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6487 0V3.1981H61.7883L61.688 1.85506H59.4633V10.3095L60.7588 10.5574V12H55.7446V10.5574L57.0401 10.3095V1.85506H54.8236L54.7233 3.1981H52.8711V0H63.6466H63.6487Z",
    fill: "#BA2025"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2414 6.72536H68.1481V10.1531H72.049L72.1575 8.71859H73.9995V11.998H64.4355V10.5554L65.7229 10.3075V1.69861L64.4355 1.45073V0H73.9831V3.2875H72.1227L72.0142 1.85303H68.1461V4.8703H72.2394V6.72536H72.2414Z",
    fill: "#BA2025"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevateLogoSmall);
export default __webpack_public_path__ + "static/media/elevateLogoSmall.85e89f8937d0900cee9979ce27ad40c7.svg";
export { ForwardRef as ReactComponent };